export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const numericRegex = /^[0-9]+$/;
